import React, { useEffect } from "react";
import { BalanceCard, TimeOffForm, WeeklyTimeoffTile, TimeoffBalanceFilter } from "../../components/timeOff";
import { Umbrella, Briefcase, Clock, Users, ArrowRight } from "lucide-react";
import { useAppDispatch } from "../../redux/store";
import { getTimeoffCategoryList } from "../../redux/features/timeoff";
import { useNavigate } from "react-router";

const RequestTimeOff: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getTimeoffCategoryList());
    }, []);

    const navToViewAllTimeoff = () => {
        navigate("/view-all-timeoff-requests");
    };

    return (
        <div className="p-6 max-w-screen mx-auto bg-white rounded-md shadow-md">
            <header className="flex items-center p-4 border-b border-gray-200">
                {/* <button className="flex items-center text-green-600 hover:text-green-800">
                    <ArrowLeft className="mr-2" />
                    Back
                    </button> */}
                <h1 className="text-xl font-semibold ml-4">Request Time Off</h1>
            </header>

            <div className="flex flex-col md:flex-row gap-6 p-4">
                {/* Left Section - Time Off Form */}
                <div className="flex-1">
                    <TimeOffForm />
                </div>

                {/* Right Section - Now in Column Layout (Balance + Weekly Timeoff) */}
                <div className="flex flex-col w-full md:w-1/3">
                    {/* <div>
                        <h2 className="text-lg font-medium mb-4 text-gray-700">Balance as of 01/22/2025</h2>
                        <div className="flex flex-col space-y-2">
                            <BalanceCard title="Vacation" amount="160 hours available" icon={<Umbrella />} />
                            <BalanceCard title="Bereavement" amount="0 days used (YTD)" icon={<Briefcase />} />
                            <BalanceCard title="Comp/In Lieu Time" amount="0 hours used (YTD)" icon={<Clock />} />
                            <BalanceCard title="FMLA" amount="0 hours used (YTD)" icon={<Users />} />
                        </div>
                    </div> */}

                    <TimeoffBalanceFilter />

                    {/* Wrapped WeeklyTimeoffTile in a div to maintain layout */}
                    <div className="w-full mt-2">
                        <WeeklyTimeoffTile />
                    </div>

                    <div onClick={navToViewAllTimeoff}></div>
                </div>
            </div>

            {/* <FooterButtons /> Uncomment if needed */}
        </div>
    );
};

export default RequestTimeOff;
